if (!customElements.get('product-picker')) {
  class ProductPicker extends HTMLElement {
    constructor () {
      super();

      this.products = [];
    }

    async changeHandle (e) {
      const productUrl = e.target.getAttribute('data-product-url');
      if (productUrl) {
        let product = this.products.find((item) => item.url === productUrl);
        if (!product) {
          const response = await fetch(`${productUrl}.js`);
          product = await response.json();
          if (!this.products.find((item) => product.id === item.id)) {
            this.products.push(product);
          }
        }
        document.dispatchEvent(
          new CustomEvent('ProductChanged', { detail: { productID: product.id, product: product } }));
      }
    }

    connectedCallback () {
      this.controllers = this.querySelectorAll('input[type=radio]');
      this.controllers.forEach((item) => {
        item.addEventListener('change', this.changeHandle.bind(this));
      });
    }

    disconnectedCallback () {
      this.controllers.forEach((item) => {
        item.removeEventListener('change', this.changeHandle.bind(this));
      });
    }
  }

  customElements.define('product-picker', ProductPicker);
}

